import React from "react";

export const SessionContext = React.createContext({
    profile: null,
    setProfile: () => {}
} as any)
